import { render, staticRenderFns } from "./colorselection.vue?vue&type=template&id=2bd0385c&scoped=true&"
import script from "./colorselection.vue?vue&type=script&lang=js&"
export * from "./colorselection.vue?vue&type=script&lang=js&"
import style0 from "./colorselection.vue?vue&type=style&index=0&id=2bd0385c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0385c",
  null
  
)

export default component.exports